











import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { AccountingJournal } from '@accounting/interfaces/accounting-journal';
import FieldWrapper from './field-wrapper/field-wrapper.vue';
import { DocumentNumberHelper } from '@accounting/helpers/DocumentNumberHelper';

@Component({
  name: 'bpc-document-number-structure-example',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class DocumentNumberStructureExample extends mixins(AbstractField) {
  @Prop({ type: Object }) declare readonly formModel: AccountingJournal;

  rand = 18;

  get exampleDocumentNumber(): string {
    return DocumentNumberHelper.getDocumentNumber(this.rand, this.formModel);
  }

  mounted() {
    // We keep a fix value to avoid misunderstandings
    // this.rand = this.generateRandomSequenceNumber();
  }

  generateRandomSequenceNumber(): number {
    return Math.ceil(Math.random() * 8); // 1-9
  }
}
